import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import api from '../../api/axios';
import Topbar from '../layout/Topbar';
import ItemMember from './ItemMember';
import { useBookStore } from '../../provider/BookStore';

const Member = () => {
    const bookState = useBookStore();
    const book = bookState.book;
    const [members, setMembers] = useState([]);
    const navigate = useNavigate();


    useEffect(() => {
        if(book.id === undefined){
            navigate('/',{replace:true})
        }
        getMembers();
    }, []);


    const getMembers = async () => {
        await api.post('/members', {
            book_id: book.id,
        }).then(res => {
            setMembers(res.data.members)
            console.log(res.data.members)
        })
    }

    const goAddMember = () => {
        navigate('/member/add');
    }

    return (
        <div>
            <Topbar
                title={'Member'}
                back={()=>navigate('/book')}
            />
            <div className='container p-5'>
                <div className="columns is-centered">
                    <div className="column is-5-widescreen is-6-desktop is-7-tablet">

                        <p className='is-size-6 mb-4 ml-4'>Buku Kas : {book.title}</p>

                        <button className='button is-floating is-primary' onClick={goAddMember}>
                            <span className='icon has-text-white'><i className="fa fa-plus"></i></span>
                        </button>


                        {members.map((item, index) => (
                            <div key={index} className='card mt-5'>
                                <ItemMember member={item} />
                            </div>
                        ))}

                    </div>
                </div>

            </div>
        </div>
    )
}

export default Member
